import db from "../indexDB/Database";

// The login token and current user live in IndexedDB, which every tab shares
// but which also survives closing the browser. This cookie marks "the browser
// has been open since this login": it has no Expires, so it is a session
// cookie the browser deletes when it closes (not when a tab closes). On app
// load, a saved login without the cookie means the browser was closed since —
// so the login is dropped and the user signs in again.
const COOKIE_NAME = "wlx_browser_session";

export const markBrowserSession = () => {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE_NAME}=1; path=/; SameSite=Lax${secure}`;
};

const hasBrowserSession = () =>
  document.cookie.split("; ").some((c) => c === `${COOKIE_NAME}=1`);

/** Run once on app load, before the saved token and user are read. */
export const endSessionIfBrowserWasClosed = async () => {
  if (hasBrowserSession()) return;
  try {
    await Promise.all([db.clearTable("authToken"), db.clearTable("currentUser")]);
  } catch {}
};
